import {elementInViewport} from "@/utils/utils.js"

export default async () => {
      // map and station-domain apps

  let throttleTimer;
  const throttleDelay = 100;

  async function initMaps() {
    const mainMapRoot = document.querySelector('#tf-map--wrapper');
    if (mainMapRoot && elementInViewport(mainMapRoot)) {
      await window.appInitializer.initMainMapApp()
      await window.appInitializer.initStationDomainApp()

      window.removeEventListener('scroll', throttledInitMaps)
    }
  }

  function throttledInitMaps() {
    clearTimeout(throttleTimer);
    throttleTimer = setTimeout(initMaps, throttleDelay);
  }

  window.addEventListener('scroll', throttledInitMaps)

}